module.exports = __webpack_public_path__ + "static/img/flag_2.7eb84c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/flag_2.png
// module id = kJBS
// module chunks = 1